import { createFileRoute } from '@tanstack/react-router'
import { Roles } from '@/features/roles'

// Per-column text filter (example for username)

export const Route = createFileRoute('/_authenticated/roles/')({
  component: Roles,
})
